export default "__VITE_ASSET__bc17487c__"